import { get, post } from "../util/accountSignConfig";
import { getSign, getStamp, getRandom } from '../util/util'

// 获取加入松鼠系统信息
export const info = (params) => {
  params.timestamp = getStamp()
  params.rand = getRandom(6)
  params.sign = getSign(params)
  return post("/join/info", params)
}

// 确认加入松鼠系统 
export const agree = (params) => {
  params.timestamp = getStamp()
  params.rand = getRandom(6)
  params.sign = getSign(params)
 return post("/join/agree", params)
}
// 创建统一账号 
export const createAccount = (params) => {
  params.timestamp = getStamp()
  params.rand = getRandom(6)
  params.sign = getSign(params)
  return post("/join/createAccount", params)
}

// 获取更换手机号码信息
export const changePhoneInfo = (params) => {
  params.timestamp = getStamp()
  params.rand = getRandom(6)
  params.sign = getSign(params)
  return post("/apply/changePhoneInfo", params)
}

// 确认更换手机号码 
export const agreeChangePhone = (params) => {
  params.timestamp = getStamp()
  params.rand = getRandom(6)
  params.sign = getSign(params)
  return post("/apply/agreeChangePhone", params)
}